import { render, staticRenderFns } from "./Deputies.vue?vue&type=template&id=962c9068"
import script from "./Deputies.vue?vue&type=script&lang=js"
export * from "./Deputies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports